import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
  AfterViewInit,
} from '@angular/core';
import { AppComponent } from 'src/app/app.component';
declare var $;
import { NavService } from 'src/app/_services/nav.service';
import { SortService } from 'src/app/_services/sort.service';
import {
  SortColumn,
  SortDirection,
  SortEvent,
  NgbdSortableHeader,
} from '../../informes/irm/sortable.directive';
import { IrmReportService } from 'src/app/_services/irmReport.service';
import { pickBy, identity } from 'lodash';
import { IrmReport } from 'src/models/irmReport.model';
import { IrmLabel } from 'src/models/irmLabel.model';
import { CompanyService } from 'src/app/_services/company.service';
import { ToastrService } from 'src/app/_services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { SyncService } from 'src/app/_services/sync.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { HttpResponse } from '@angular/common/http';
import { FilesControlService } from 'src/app/_services/files-control.service';
import { Router } from '@angular/router';
import { PopupLimiteRegistrosComponent } from '../../informes/components/popup-limite-registros/popup-limite-registros.component';

declare var bootstrapSelect: any;

@Component({
  selector: 'files-control',
  templateUrl: './files-control.component.html',
  styleUrls: ['./files-control.component.css'],
})
export class FilesControlComponent implements OnInit {
  fakeData = [
    {
      id: 'ac380822-f082-4b3c-bf86-508ef0807db8',
      creationDate: '2024-05-05T00:05:34',
      expirationDate: null,
      fileType: 'Archive',
      modificationDate: '2024-05-09T23:11:14',
      modificationUser: 'fernando.moreno@nunsys.com',
      fileName:
        'policy.fernando.moreno@nunsys.com.ec8ce689-763e-4ba8-83b3-4834cd67e706_ADAL.gz',
      department: 'Producto 1',
      ownerUser: 'fernando.moreno@nunsys.com',
      label: null,
      location: 'Endpoint devices',
    },
  ];

  REPORTS: IrmReport[] = [];

  data: { title: 'Informes' };
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  reports: any;
  page = 1;
  pageSize = 10;
  collectionSize = this.REPORTS?.length;

  sortColumn: SortColumn;
  sortDirection: SortDirection;

  sortState: any;

  fileName: string;
  user: string;
  locations: any;
  selectedLocations: any[] = [];
  labels: IrmLabel[] = [];
  selectedLabels: any[] = [];
  departments: string[] = [];
  selectedDeptos: any[] = [];
  minDate: any;
  maxDate: any;
  rangeDate: any;
  maxDateInput: Date = new Date();

  labelsName: string[] = [];

  areFiltersCollapsed = true;

  isLoading: boolean = true;

  filters: any;

  maxLength: number = 30;

  todasLasOpciones: [] = [];

  protected ngbModalRef: NgbModalRef;

  checkboxSi: boolean = false;
  checkboxNo: boolean = false;
  limit: any;
  savedSortStr: any;

  // tslint:disable-next-line: max-line-length
  constructor(
    private appComponent: AppComponent,
    private navService: NavService,
    private sortService: SortService,
    private irmReportService: IrmReportService,
    private companyService: CompanyService,
    private toastrService: ToastrService,
    private translate: TranslateService,
    private filesControlService: FilesControlService,
    private modalService: NgbModal,
    public router: Router
  ) {
    Window['appuser'] = this;
  }

  ngOnInit() {
    this.isLoading = true;
    const today = new Date();
    this.maxDate = today;
    this.minDate = new Date(today);
    this.minDate.setDate(this.minDate.getDate() - 7);

    this.loadCachedFilters(); // Cargar filtros guardados

    this.getDepartments();
    this.getLabels();
    this.getLocations();

    this.selectedNavItem({
      parent: 'menu.reports.reports',
      child: 'menu.utilities.fileTraceability',
      description: 'pageDescriptions.filesControl',
    });
  }

  ngAfterViewInit() {
    this.restoreSort();
    this.headers.changes.subscribe(() => {
      this.restoreSort();
    });
  }

  restoreSort() {
    if (this.sortColumn && this.sortDirection) {
      setTimeout(() => {
        const activeHeader = this.headers?.find(
          (h) => h.sortable === this.sortColumn
        );
        if (activeHeader) {
          activeHeader.direction = this.sortDirection;
        }
      });
    }
  }

  formatDate(selectedDate: Date): string {
    const day = selectedDate?.getDate()?.toString()?.padStart(2, '0');
    const month = (selectedDate?.getMonth() + 1)?.toString()?.padStart(2, '0');
    const year = selectedDate?.getFullYear()?.toString();

    return `${year}-${month}-${day}`;
  }

  setFilters(firstTime?) {
    if (firstTime) {
      this.sortState = {
        sort: 'modificationDate',
        order: 'desc',
      };
    }

    if (this.checkboxSi && !this.checkboxNo) {
      this.limit = true;
    } else if (!this.checkboxSi && this.checkboxNo) {
      this.limit = false;
    } else {
      this.limit = undefined;
    }

    const filters = {
      location:
        this.selectedLocations?.length > 0 ? this.selectedLocations : [],
      label: this.selectedLabels?.length > 0 ? this.selectedLabels : [],
      department: this.selectedDeptos?.length > 0 ? this.selectedDeptos : [],
      dateStart: this.minDate && this.formatDate(this.minDate),
      dateEnd: this.maxDate && this.formatDate(this.maxDate),
      fileName: this.fileName && this.fileName,
      user: this.user && this.user,
      sensibleData: this.limit,
    };

    this.filters = {
      ...filters,
      sort: this.sortState?.sort,
      order: this.sortState?.order,
    };

    this.filters = pickBy(this.filters, (v) => v !== undefined);
    this.page = 1;

    this.cacheFilters(); // Guardar filtros en caché
    console.log('entro aca');
    this.refreshReports(firstTime);
  }

  cleanFilters() {
    this.fileName = undefined;
    this.user = undefined;
    this.selectedLabels = undefined;
    this.selectedDeptos = undefined;
    this.selectedLocations = undefined;
    this.minDate = undefined;
    this.maxDate = undefined;
    this.filters = undefined;
    this.rangeDate = undefined;
    this.checkboxNo = undefined;
    this.checkboxSi = undefined;
    this.sortState = undefined;
    this.sortColumn = undefined;
    this.sortDirection = undefined;
    this.filters = {
      ...this.filters,
      sort: this.sortState?.sort,
      order: this.sortState?.order,
    };

    this.filters = pickBy(this.filters, (v) => v !== undefined);
    this.page = 1;

    window.sessionStorage.removeItem('informesFilesControlFilters');
    this.setFilters();
  }

  cacheFilters() {
    const filtersToSave = {
      ...this.filters,
      fileName: this.fileName,
      user: this.user,
      location: this.selectedLocations,
      label: this.selectedLabels,
      department: this.selectedDeptos,
      dateStart: this.minDate,
      dateEnd: this.maxDate,
      sensibleData: this.limit,
      checkboxSi: this.checkboxSi,
      checkboxNo: this.checkboxNo,
      sortState: this.sortState,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection,
    };
    window.sessionStorage.setItem(
      'informesFilesControlFilters',
      JSON.stringify(filtersToSave)
    );
  }

  loadCachedFilters() {
    const cachedFilters = window.sessionStorage.getItem(
      'informesFilesControlFilters'
    );
    const cachedSort = window.sessionStorage.getItem(
      'informesFilesControlSort'
    );
    if (cachedSort) {
      this.savedSortStr = JSON.parse(cachedSort);
    }

    if (cachedFilters) {
      this.areFiltersCollapsed = false;
      const filters = JSON.parse(cachedFilters);
      this.fileName = filters.fileName;
      this.user = filters.user;
      this.selectedLocations = filters.location || [];
      this.selectedLabels = filters.label || [];
      this.selectedDeptos = filters.department || [];
      this.minDate = filters.dateStart
        ? new Date(filters.dateStart)
        : undefined;
      this.maxDate = filters.dateEnd ? new Date(filters.dateEnd) : undefined;
      this.checkboxSi = filters.checkboxSi || false;
      this.checkboxNo = filters.checkboxNo || false;
      this.limit = filters.sensibleData;
      this.sortState = filters.sortState;
      this.sortColumn = filters.sortColumn;
      this.sortDirection = filters.sortDirection;
      this.filters = filters;

      if (
        this.fileName ||
        this.user ||
        this.selectedLocations.length > 0 ||
        this.selectedLabels.length > 0 ||
        this.selectedDeptos.length > 0 ||
        this.checkboxSi ||
        this.checkboxNo
      ) {
        this.areFiltersCollapsed = false;
      } else {
        this.areFiltersCollapsed = true;
      }

      this.refreshReports(false);
    } else {
      this.setFilters();
    }
  }

  refreshReports(firstTime?) {
    if (firstTime) {
      this.filters = {
        ...this.filters,
        sort: ['modificationDate'],
        order: ['desc'],
      };
    }
    this.isLoading = true;
    console.log('entro aca');
    this.filesControlService
      .getAllFiles(this.page - 1, this.filters, this.pageSize)
      .subscribe(
        (res) => {
          this.isLoading = false;
          this.collectionSize = res.body['total'];
          this.reports = res.body['results'];
        },
        (err) => (this.isLoading = false)
      );
  }

  getUsers() {
    /*
    this.filesControlService.getUsers().subscribe((res) => {
      this.users = res.body;
    });
    */
  }

  getLabels() {
    this.irmReportService.getLabels().subscribe((res) => {
      this.labels = res.body;
      this.labelsName = this.labels.map((label) => label.name);
    });
  }

  getDepartments() {
    this.companyService.getDepartments().subscribe((res) => {
      this.todasLasOpciones = res.body;
      this.departments = this.todasLasOpciones.slice(0, 20);
    });
  }

  getLocations() {
    this.filesControlService.getLocations().subscribe((res) => {
      this.locations = res.body;
    });
  }

  cargarMasOpciones() {
    // Carga más opciones a 'opcionesPaginadas' al hacer scroll o al presionar un botón
    const inicio = this.departments?.length;
    const fin = inicio + 20;
    this.departments = this.departments.concat(
      this.todasLasOpciones.slice(inicio, fin)
    );
  }

  download() {
    /*    this.syncService.download(this.filters).subscribe((response: HttpResponse<Blob>) => {
      this.createDownloadLink(response)
    }); */
  }

  generateGeneralIrmReport() {
    if (this.collectionSize > 500000) {
      this.ngbModalRef = this.modalService.open(PopupLimiteRegistrosComponent, {
        size: 'lg',
        backdrop: 'static',
      });
      this.ngbModalRef.componentInstance.cantidadRegistros =
        this.collectionSize;
      this.ngbModalRef.result.then((result) => {
        if (result === 'continuar') {
          this.reqGeneralIrmReport();
        }
      });
    } else {
      this.reqGeneralIrmReport();
    }
  }

  reqGeneralIrmReport() {
    // Se toman las fechas directo del date-picker (minDate/maxDate) en vez de
    // this.filters.dateStart/dateEnd, que solo se sincroniza al apretar
    // "Aplicar filtros" - si el usuario genera el informe sin aplicar antes,
    // this.filters queda con fechas viejas/vacías y el backend cae en su
    // rango por defecto de 10 años.
    const filtersRenamed = {
      ...this.filters,
      dateBegin: this.minDate ? this.formatDate(this.minDate) : undefined,
      dateEnd: this.maxDate ? this.formatDate(this.maxDate) : undefined,
    };

    if (filtersRenamed.dateBegin) {
      filtersRenamed.dateBegin = this.formatDateToDDMMYY(
        filtersRenamed.dateBegin
      );
    } else {
      delete filtersRenamed.dateBegin;
    }

    if (filtersRenamed.dateEnd) {
      filtersRenamed.dateEnd = this.formatDateToDDMMYY(filtersRenamed.dateEnd);
    } else {
      delete filtersRenamed.dateEnd;
    }

    this.toastrService.info(this.translate.instant('generatingReport'));
    delete filtersRenamed.dateStart;

    this.filesControlService
      .generateGeneraFilesControlReport(
        filtersRenamed,
        this.translate.currentLang
      )
      .subscribe(
        (res) => {
          this.toastrService.info(
            this.translate.instant('generateFilesControlReport')
          );
        },
        (error) => {
          this.toastrService.error(
            'Ha ocurrido un error al generar el reporte.'
          );
        }
      );
  }

  private formatDateToDDMMYY(date: string): string {
    const [year, month, day] = date.split('-');
    return `${day}.${month}.${year.slice(-2)}`;
  }
  createDownloadLink(response: HttpResponse<Blob>) {
    let filename = 'logHistory.xlsx'; // Nombre de archivo por defecto
    const contentDispositionHeader = response.headers.get(
      'Content-Disposition'
    );
    if (contentDispositionHeader) {
      const matches = /filename="?([^"]+)"?;?/i.exec(contentDispositionHeader);
      filename = matches && matches.length > 1 ? matches[1] : filename;
    } else if (response.url) {
      const urlParts = response.url.split('/');
      filename = urlParts[urlParts.length - 1];
    }

    const blob = new Blob([response.body], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;

    document.body.appendChild(link);
    link.click();

    URL.revokeObjectURL(url);
    document.body.removeChild(link);
  }

  seeDetails(id) {
    this.router.navigate([`/home/informes/FilesControl/${id}`]);
  }

  generateEvoIrmReport() {
    this.toastrService.info(this.translate.instant('generatingReport'));
    this.irmReportService
      .generateEvoIrmReport(this.filters, this.translate.currentLang)
      .subscribe(
        (res) => {
          this.toastrService.successReport(
            this.translate.instant('generatedIrmEvo')
          );
        },
        (error) => {
          this.toastrService.error(this.translate.instant('errorReport'));
        }
      );
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.sortColumn = column;
    this.sortDirection = direction;

    if (this.sortDirection !== '') {
      this.filters = {
        ...this.filters,
        sort: this.sortColumn,
        order: this.sortDirection,
      };
      this.sortState = {
        sort: this.sortColumn,
        order: this.sortDirection,
      };
    } else {
      delete this.filters.sort;
      delete this.filters.order;
      this.sortState = undefined;
    }
    this.cacheFilters();
    this.refreshReports();
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }

  setDate(event) {
    this.minDate = event[0];
    this.maxDate = event[1];
  }
}
